import React from "react";
import { Helmet } from "react-helmet";

import {
  PrimaryAboutContainer,
  AboutImage,
  AboutTitle,
  AboutSubTitle,
  AboutTexts,
  PrimaryBodyText,
  Container,
  TitleContainer,
  ImageWrapper,
  PrimaryHeader,
  Background,
} from "./About.styles";
import { ABOUT_1 } from "../../image-links";
import {
  ABOUT_BLURB_1_TEXT,
  ABOUT_BLURB_1_TITLE,
  ABOUT_BLURB_2_TEXT,
  ABOUT_BLURB_2_TITLE,
  ABOUT_TITLE,
} from "../../text";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us | The Science Spotlight</title>
        <meta
          name="og:title"
          property="og:title"
          content="About Us | The Science Spotlight"
        />
        <meta
          name="og:description"
          property="og:description"
          content="The Science Spotlight is a daily email newsletter about science history. Learn more about us and sign up today!"
        />
        <meta
          name="description"
          property="description"
          content="The Science Spotlight is a daily email newsletter about science history. Learn more about us and sign up today!"
        />
      </Helmet>
      <Container>
        <TitleContainer>
          <AboutTitle>{ABOUT_TITLE}</AboutTitle>
        </TitleContainer>
        <PrimaryAboutContainer>
          <ImageWrapper>
            <AboutImage src={ABOUT_1} alt="about-image" />
          </ImageWrapper>
          <AboutTexts>
            <PrimaryHeader>{ABOUT_BLURB_1_TITLE}</PrimaryHeader>
            <PrimaryBodyText>{ABOUT_BLURB_1_TEXT}</PrimaryBodyText>
            <AboutSubTitle>{ABOUT_BLURB_2_TITLE}</AboutSubTitle>
            <PrimaryBodyText>{ABOUT_BLURB_2_TEXT}</PrimaryBodyText>
          </AboutTexts>
        </PrimaryAboutContainer>
        <Background />
      </Container>
    </>
  );
};

export default About;
